// Ce script permet aux boutons maquettes sur les pages programmes de : 
// - Quand on est sur un écran > 750px : on affiche la maquette dans un iframe
// - Quand on est sur un écran < 750px : on affiche la maquette dans un nouvel onglet

document.addEventListener("DOMContentLoaded", function () {
    const btnMaquette = document.getElementById("maquette3d-btn");
    const modalMaquette = document.getElementById("maquette3d");
    const closeBtnMaquette = document.getElementById("close-maquette3d");

    if (!btnMaquette || !modalMaquette) return;

    // Au click sur le bouton -> On vérifie la taille de l'écran, et soit on ouvre l'URL dans un nouvel onglet, soit on affiche la modal (avec la classe is-active)
    btnMaquette.addEventListener("click", function (event) {
        event.preventDefault();
        const url = btnMaquette.getAttribute("data-url");

        if (window.innerWidth < 750) {
            window.open(url, "_blank");
        } else {
            modalMaquette.classList.add("is-active"); // Afficher la modale sur desktop
        }
    });

    // Au click sur la croix -> On cache le modal (en retirant la classe is-active)
    closeBtnMaquette.addEventListener("click", function () {
        modalMaquette.classList.remove("is-active"); // Fermer la modale
    });
});